<template>
  <div class="preference-chart-input">
    <component
      ref="preference_input"
      v-if="componentName"
      :is="componentName"
      :job-question="jobQuestion"
      :for-question-form="forQuestionForm"
      :study-question="studyQuestion"
      :no-preference-value="noPreferenceValue"
      @set-preference="onSetPreference"
    />
  </div>
</template>

<script>
import SelectOnePreferenceInput from '@/components/exchange/preference-charts-inputs/SelectOnePreferenceInput';
import YesNoPreferenceInput from '@/components/exchange/preference-charts-inputs/YesNoPreferenceInput';
import SelectAnyPreferenceInput from '@/components/exchange/preference-charts-inputs/SelectAnyPreferenceInput';
import RatingPreferenceInput from '@/components/exchange/preference-charts-inputs/RatingPreferenceInput';
import SliderPreferenceInput from '@/components/exchange/preference-charts-inputs/SliderPreferenceInput';
import GeographyPreferenceInput from '@/components/exchange/preference-charts-inputs/GeographyPreferenceInput';
import { JOB_QUESTION_TYPES } from '@/store';
import MultiVariableSelectOnePreferenceInput from '@/components/exchange/preference-charts-inputs/MultiVariableSelectOnePreferenceInput';

export default {
  name: 'PreferenceChartInput',
  components: {
    SelectOnePreferenceInput,
    YesNoPreferenceInput,
    SelectAnyPreferenceInput,
    RatingPreferenceInput,
    SliderPreferenceInput,
    GeographyPreferenceInput,
    MultiVariableSelectOnePreferenceInput,
  },
  props: {
    jobQuestion: {
      required: true,
    },
    forQuestionForm: {
      type: Boolean,
      default: false,
    },
    studyQuestion: {
      default: null,
    },
    noPreferenceValue: Number,
  },
  computed: {
    componentName: function () {
      switch (this.jobQuestion.type) {
        case JOB_QUESTION_TYPES.YES_NO:
          return YesNoPreferenceInput.name;
        case JOB_QUESTION_TYPES.SELECT_ONE:
          return SelectOnePreferenceInput.name;
        case JOB_QUESTION_TYPES.SELECT_ANY:
          return SelectAnyPreferenceInput.name;
        case JOB_QUESTION_TYPES.RATING:
          return RatingPreferenceInput.name;
        case JOB_QUESTION_TYPES.SLIDER:
          return SliderPreferenceInput.name;
        case JOB_QUESTION_TYPES.GEOGRAPHY:
          return GeographyPreferenceInput.name;
        case JOB_QUESTION_TYPES.MULTI_VARIABLE_SELECT_ONE:
          return MultiVariableSelectOnePreferenceInput.name;
        default:
          return null;
      }
    },
  },
  methods: {
    onSetPreference: function () {
      this.$emit('set-preference', ...arguments);
    },
    isDirty: function () {
      if (typeof this.$refs.preference_input.isDirty !== 'function') {
        throw new Error(
          'Each preference input component should implement isDirty method'
        );
      }
      return this.$refs.preference_input.isDirty();
    },
    hasErrors: function () {
      if (typeof this.$refs.preference_input.hasErrors !== 'function') {
        throw new Error(
          'Each preference input component should implement hasErrors method'
        );
      }
      return this.$refs.preference_input.hasErrors();
    },
    resetValidation: function () {
      if (typeof this.$refs.preference_input.resetValidation !== 'function') {
        throw new Error(
          'Each preference input component should implement resetValidation method'
        );
      }
      return this.$refs.preference_input.resetValidation();
    },
  },
};
</script>

<style scoped></style>
